import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/products/hosting")({
  beforeLoad: () => {
    throw redirect({
      to: "/products/$category",
      params: { category: "web-hosting" },
    });
  },
});
